export const imports = {
  'README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "readme" */ 'README.mdx'
    ),
  'AdvancedSearch/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "advanced-search-readme" */ 'AdvancedSearch/README.mdx'
    ),
  'Affix/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "affix-readme" */ 'Affix/README.mdx'
    ),
  'Alert/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "alert-readme" */ 'Alert/README.mdx'
    ),
  'AppStatusPage/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "app-status-page-readme" */ 'AppStatusPage/README.mdx'
    ),
  'AutoComplete/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "auto-complete-readme" */ 'AutoComplete/README.mdx'
    ),
  'Avatar/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "avatar-readme" */ 'Avatar/README.mdx'
    ),
  'Badge/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "badge-readme" */ 'Badge/README.mdx'
    ),
  'Breadcrumb/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "breadcrumb-readme" */ 'Breadcrumb/README.mdx'
    ),
  'Button/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "button-readme" */ 'Button/README.mdx'
    ),
  'Calendar/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "calendar-readme" */ 'Calendar/README.mdx'
    ),
  'Card/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "card-readme" */ 'Card/README.mdx'
    ),
  'CardLegacy/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "card-legacy-readme" */ 'CardLegacy/README.mdx'
    ),
  'Cascader/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "cascader-readme" */ 'Cascader/README.mdx'
    ),
  'Col/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "col-readme" */ 'Col/README.mdx'
    ),
  'Checkbox/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "checkbox-readme" */ 'Checkbox/README.mdx'
    ),
  'Collapse/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "collapse-readme" */ 'Collapse/README.mdx'
    ),
  'CommentModal/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "comment-modal-readme" */ 'CommentModal/README.mdx'
    ),
  'CompanyAvatar/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "company-avatar-readme" */ 'CompanyAvatar/README.mdx'
    ),
  'Compass/readme.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "compass-readme" */ 'Compass/readme.mdx'
    ),
  'CrewOnBoard/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "crew-on-board-readme" */ 'CrewOnBoard/README.mdx'
    ),
  'DatePicker/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "date-picker-readme" */ 'DatePicker/README.mdx'
    ),
  'DestinationIcon/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "destination-icon-readme" */ 'DestinationIcon/README.mdx'
    ),
  'Divider/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "divider-readme" */ 'Divider/README.mdx'
    ),
  'Drawer/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "drawer-readme" */ 'Drawer/README.mdx'
    ),
  'Dropdown/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "dropdown-readme" */ 'Dropdown/README.mdx'
    ),
  'DropdownNew/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "dropdown-new-readme" */ 'DropdownNew/README.mdx'
    ),
  'Empty/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "empty-readme" */ 'Empty/README.mdx'
    ),
  'Flyout/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "flyout-readme" */ 'Flyout/README.mdx'
    ),
  'Form/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "form-readme" */ 'Form/README.mdx'
    ),
  'Header/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "header-readme" */ 'Header/README.mdx'
    ),
  'HeaderAffix/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "header-affix-readme" */ 'HeaderAffix/README.mdx'
    ),
  'HeaderDetails/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "header-details-readme" */ 'HeaderDetails/README.mdx'
    ),
  'Icon/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "icon-readme" */ 'Icon/README.mdx'
    ),
  'InfoBadge/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "info-badge-readme" */ 'InfoBadge/README.mdx'
    ),
  'Input/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "input-readme" */ 'Input/README.mdx'
    ),
  'InputNumber/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "input-number-readme" */ 'InputNumber/README.mdx'
    ),
  'KeyValueTable/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "key-value-table-readme" */ 'KeyValueTable/README.mdx'
    ),
  'Layout/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "layout-readme" */ 'Layout/README.mdx'
    ),
  'LayoutContent/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "layout-content-readme" */ 'LayoutContent/README.mdx'
    ),
  'Loader/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "loader-readme" */ 'Loader/README.mdx'
    ),
  'List/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "list-readme" */ 'List/README.mdx'
    ),
  'Logo/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "logo-readme" */ 'Logo/README.mdx'
    ),
  'Menu/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "menu-readme" */ 'Menu/README.mdx'
    ),
  'Modal/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "modal-readme" */ 'Modal/README.mdx'
    ),
  'PageHeader/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "page-header-readme" */ 'PageHeader/README.mdx'
    ),
  'Pagination/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "pagination-readme" */ 'Pagination/README.mdx'
    ),
  'Panel/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "panel-readme" */ 'Panel/README.mdx'
    ),
  'Popconfirm/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "popconfirm-readme" */ 'Popconfirm/README.mdx'
    ),
  'Popover/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "popover-readme" */ 'Popover/README.mdx'
    ),
  'ProductIcon/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "product-icon-readme" */ 'ProductIcon/README.mdx'
    ),
  'Progress/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "progress-readme" */ 'Progress/README.mdx'
    ),
  'Radio/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "radio-readme" */ 'Radio/README.mdx'
    ),
  'Rate/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "rate-readme" */ 'Rate/README.mdx'
    ),
  'Roundel/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "roundel-readme" */ 'Roundel/README.mdx'
    ),
  'Row/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "row-readme" */ 'Row/README.mdx'
    ),
  'Search/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "search-readme" */ 'Search/README.mdx'
    ),
  'SearchField/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "search-field-readme" */ 'SearchField/README.mdx'
    ),
  'Select/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "select-readme" */ 'Select/README.mdx'
    ),
  'Slider/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slider-readme" */ 'Slider/README.mdx'
    ),
  'Spin/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "spin-readme" */ 'Spin/README.mdx'
    ),
  'StatusLabel/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "status-label-readme" */ 'StatusLabel/README.mdx'
    ),
  'Steps/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "steps-readme" */ 'Steps/README.mdx'
    ),
  'Switch/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "switch-readme" */ 'Switch/README.mdx'
    ),
  'TabPane/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tab-pane-readme" */ 'TabPane/README.mdx'
    ),
  'Table/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "table-readme" */ 'Table/README.mdx'
    ),
  'Tabs/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tabs-readme" */ 'Tabs/README.mdx'
    ),
  'Tag/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tag-readme" */ 'Tag/README.mdx'
    ),
  'TimePicker/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "time-picker-readme" */ 'TimePicker/README.mdx'
    ),
  'Timeline/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "timeline-readme" */ 'Timeline/README.mdx'
    ),
  'Tooltip/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tooltip-readme" */ 'Tooltip/README.mdx'
    ),
  'Transfer/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "transfer-readme" */ 'Transfer/README.mdx'
    ),
  'Tree/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "tree-readme" */ 'Tree/README.mdx'
    ),
  'Upload/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "upload-readme" */ 'Upload/README.mdx'
    ),
  'VesselPortDetails/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-port-details-readme" */ 'VesselPortDetails/README.mdx'
    ),
  'VesselPortSearch/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-port-search-readme" */ 'VesselPortSearch/README.mdx'
    ),
  'WhiteBox/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "white-box-readme" */ 'WhiteBox/README.mdx'
    ),
  'icons/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "icons-readme" */ 'icons/README.mdx'
    ),
  'message/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "message-readme" */ 'message/README.mdx'
    ),
  'notification/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "notification-readme" */ 'notification/README.mdx'
    ),
  'Vessel/AISBadge/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-ais-badge-readme" */ 'Vessel/AISBadge/README.mdx'
    ),
  'Vessel/Map2d/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-map2d-readme" */ 'Vessel/Map2d/README.mdx'
    ),
  'Vessel/VesselItinerary/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-vessel-itinerary-readme" */ 'Vessel/VesselItinerary/README.mdx'
    ),
  'Vessel/VesselsList/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "vessel-vessels-list-readme" */ 'Vessel/VesselsList/README.mdx'
    ),
  'port/ItemSelect/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "port-item-select-readme" */ 'port/ItemSelect/README.mdx'
    ),
  'port/PTBIcon/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "port-ptb-icon-readme" */ 'port/PTBIcon/README.mdx'
    ),
  'port/PortCallModal/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "port-port-call-modal-readme" */ 'port/PortCallModal/README.mdx'
    ),
  'providers/LocaleProvider/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "providers-locale-provider-readme" */ 'providers/LocaleProvider/README.mdx'
    ),
  'providers/NamespaceProvider/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "providers-namespace-provider-readme" */ 'providers/NamespaceProvider/README.mdx'
    ),
  'providers/Theme/README.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "providers-theme-readme" */ 'providers/Theme/README.mdx'
    ),
}
